import { TextFieldEntry } from "@bpmn-io/properties-panel";
import { useService } from "bpmn-js-properties-panel";

export default function RecipientPropertiesProvider(props) {
    const { idPrefix, parameter } = props;

    const entries = [
        {
            id: idPrefix + "-name",
            component: Name,
            idPrefix,
            parameter,
        },
        {
            id: idPrefix + "-address",
            component: Address,
            idPrefix,
            parameter,
        },
    ];

    return entries;
}

function Name(props) {
    const { idPrefix, element, parameter } = props;

    const commandStack = useService("commandStack");
    const translate = useService("translate");
    const debounce = useService("debounceInput");

    const setValue = (value) => {
        commandStack.execute("element.updateModdleProperties", {
            element,
            moddleElement: parameter,
            properties: {
                name: value,
            },
        });
    };

    const getValue = (parameter) => {
        return parameter.name;
    };

    return TextFieldEntry({
        element: parameter,
        id: idPrefix + "-name",
        label: `*${translate("Name")}`,
        getValue,
        setValue,
        debounce,
    });
}

function Address(props) {
    const { idPrefix, element, parameter } = props;

    const commandStack = useService("commandStack");
    const translate = useService("translate");
    const debounce = useService("debounceInput");

    const setValue = (value) => {
        commandStack.execute("element.updateModdleProperties", {
            element,
            moddleElement: parameter,
            properties: {
                address: value,
            },
        });
    };

    const getValue = (parameter) => {
        return parameter.address;
    };

    return TextFieldEntry({
        element: parameter,
        id: idPrefix + "-address",
        label: `*${translate("Address")}`,
        getValue,
        setValue,
        debounce,
    });
}